import type { WealthChartSource } from './types'

/**
 * Whether two runs of the same chart draw the same picture.
 *
 * A scenario that changes nothing on this chart has nothing to compare against,
 * and a second run drawn exactly under the first is a line nobody can see and a
 * question — "what is that?" — with no answer. So the comparison is dropped and
 * the chart draws one run.
 *
 * Compared figure by figure rather than by identity: the two runs are computed
 * separately, so they are never the same object even when they agree.
 */
export const wealthRunsMatch = (
  run: WealthChartSource,
  other: WealthChartSource
): boolean =>
  run.length === other.length &&
  run.every((point, index) => {
    const against = other[index]!
    return (
      point.age === against.age &&
      point.networth === against.networth &&
      point.liquidAssets === against.liquidAssets
    )
  })
